module.exports = __webpack_public_path__ + "static/media/slide-1.c1c93dc0.jpg";